import {
  forwardRef,
  ButtonGroup as ChakraButtonGroup,
  ButtonGroupProps as ChakraButtonGroupProps,
  useStyleConfig
} from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

import { InferPropTypes } from '../../types';

export const variantPropTypes = ['default', 'toolbar'];
export const sizePropTypes = ['xs', 'sm', 'md', 'lg'];

const propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(sizePropTypes)
};

const defaultProps = {
  size: ''
};

export type ButtonGroupProps = ChakraButtonGroupProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

const ButtonGroup = forwardRef<ButtonGroupProps, 'div'>((props, ref) => {
  const { children, __css, ...rest } = props as ButtonGroupProps;

  const cssStyles = useStyleConfig('ButtonGroup', props);

  return (
    <ChakraButtonGroup __css={mergeWith(cssStyles, __css)} {...rest} ref={ref}>
      {children}
    </ChakraButtonGroup>
  );
});

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

export default ButtonGroup;
